module.exports = __webpack_public_path__ + "static/media/mediabg.ee9ba739.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mediabg.jpeg
// module id = 30
// module chunks = 0